import {Badge} from "@mantine/core";
import {
    Subscription,
    CustomerSubscriptionStatus
} from "../types.ts";

export const SubscriptionStatusBadge = ({record}: { record: Subscription }) => {

    let color = '';

    const message = record.status || 'Active';

    if (record.status === CustomerSubscriptionStatus.Active) {
        color = 'green';
    } else if (record.status === CustomerSubscriptionStatus.Inactive) {
        color = 'gray';
    } else {
        color = 'red';
    }
    return <Badge color={color}>{message}</Badge>;
};


